export default url => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', true);
  link.click();
};
